import { FC } from "react"
import cx from "classnames"
import { FaCheckCircle } from "react-icons/fa"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const CheckCircleIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <FaCheckCircle
      className={cx("w-5 h-5 active:scale-90", className)}
      {...rest}
    />
  )
}

export default CheckCircleIcon
